/**
 * monitor上报
 * @property  {number} id monitor id
 * @property  {string} msg 上报代码的中文含义，上报的时候会带上去，主要是为了排查问题。
 * @memberof module:monitor
 * @example
 * monitor.report(1234, 'cgi_succ')
 * @reurn {void}
 */
var cfg = {
  url: 'https://cgi.connect.qq.com/report/report_vm',
  delay: 100
};
var pool = [];

function isArray(obj) {
  return obj && Object.prototype.toString.call(obj) === '[object Array]';
}

var newImage = function newImage(url) {
  var img = new Image();

  img.onload = img.onerror = function () {
    img = null;
  };

  img.src = url;
};

var sendImg = function sendImg(url) {
  if (document.readyState === 'complete') {
    newImage(url);
  } else {
    window.addEventListener('load', function () {
      newImage(url);
    });
  }
};

var send = function send(lazyReport) {
  var src = ''; // eslint-disable-next-line

  /* istanbul ignore next */

  var ids = [];
  var msgS = [];

  for (var i = 0; i < pool.length; i++) {
    var _pool$i = pool[i],
        id = _pool$i.id,
        msg = _pool$i.msg;
    ids.push(id);
    msgS.push(msg);
  }

  if (pool.length > 0) {
    var url = "".concat(cfg.url, "?monitors=[").concat(ids.join(','), "]&_=").concat(msgS.join(',').substr(0, 1000), "&t=").concat(Math.random());

    if (lazyReport) {
      sendImg(url);
    } else {
      newImage(url);
    }
  }

  pool = [];
  return src;
};

var report = function report(id, msg) {
  var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
  var lazyReport = arguments.length > 3 ? arguments[3] : undefined;

  if (id) {
    if (isArray(id)) {
      id.forEach(function (idItem) {
        if (idItem) {
          pool.push({
            id: idItem,
            msg: msg
          });
        }
      });
    } else {
      /* istanbul ignore next */
      pool.push({
        id: id,
        msg: msg
      });
    }

    setTimeout(function () {
      var src = send(lazyReport);
      cb && cb(src);
    }, cfg.delay);
  }
};

var monitor = {
  report: report
}; // eslint-disable-next-line

export { monitor };